export interface InvoiceResponse {
  result: { dados: Invoice[] };
}
export interface Invoice {
  Date: string;
  URL_Nota_Fiscal: string;
  nfse_numero: string;
}
